import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { addMorePlan } from "../../Redux/Actions/subscriptionActions";

import { useNavigate } from "react-router-dom";
import MainLayout from "../../Layout/mainLayout";
const AddPlan = () => {
  const [planData, setPlanData] = useState({
    plan_name: "Basic",
    // plan_type: "PERIODIC",
    period: "monthly",
    interval: 1,
    amount: null,
    currency: "INR",
    before_discount_amount: null,
    position: Math.floor(Math.random() * 1000) + 1,
  });
  const Navigate = useNavigate();
  const dispatch = useDispatch();

  const { enumsData } = useSelector((state) => state.enumsData);

  const handleChange = (e) => {
    const { name, id, value } = e.target;

    if (name === "period") {
      setPlanData({
        ...planData,
        interval: enumsData?.data?.subscriptionType?.plan_intervals[value],
        [name]: value,
      });
      return;
    }

    if (id) {
      setPlanData({
        ...planData,
        [name]:
          id === "amount" ||
          id === "before_discount_amount" ||
          id === "interval"
            ? +value
            : value,
      });
    }
  };

  const handleSave = () => {
    if (
      planData.amount === null ||
      planData.amount === undefined ||
      planData.amount === 0
    ) {
      alert("Please provide all fields necessary");
    } else {
      dispatch(addMorePlan(planData, () => Navigate("/plans")));
    }
  };

  useEffect(() => {
    console.log(planData);
  }, [planData]);

  return (
    <MainLayout>
      <div className="custom-popup">
        <div className="popup-header">
          <div className="top_bar">
            <div className="child_header">
              <p>Add Plan</p>
            </div>
            <div>
              <div>
                <button
                  className="route_btn"
                  onClick={() => Navigate("/Plans")}
                >
                  Back to Plans
                </button>
              </div>
            </div>
          </div>
        </div>
        {enumsData?.data?.subscriptionType && (
          <div className="popup-body">
            <div>
              <div>
                <div>
                  <label for="plan_name">Plan Name</label>
                  <select
                    id="plan_name"
                    name="plan_name"
                    className="custom_plan_input"
                    value={planData.plan_name}
                    onChange={handleChange}
                  >
                    {Object.entries(
                      enumsData &&
                        enumsData?.data?.subscriptionType["plan_name"]
                    ).map(([Key, val], i) => (
                      <option name={"plan_name"} value={val}>
                        {val}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label for="period"> Select Recurring Type </label>
                  <select
                    name="period"
                    id="period"
                    className="custom_plan_input"
                    onChange={handleChange}
                    value={planData.period}
                  >
                    {Object.entries(
                      enumsData?.data?.subscriptionType["plan_interval_type"]
                    ).map(([Key, val], i) => (
                      <option value={val}>{val}</option>
                    ))}
                  </select>
                </div>

                {/* <div>
                  <label for="plan_type">Choose Plan</label>
                  <select
                    id="plan_type"
                    name="plan_type"
                    className="custom_plan_input"
                    value={planData.plan_type}
                    onChange={handleChange}
                  >
                    {Object.entries(
                      enumsData?.data?.subscriptionType["plan_type"]
                    ).map(([Key, val], i) => (
                      <option value={val}>{val}</option>
                    ))}
                  </select>
                </div> */}
              </div>
              <div>
                {/* {planData.period !== "DAY" ? (
                  <div>
                    <label for="interval"> Select Recurring Interval</label>
                    <select
                      disabled={planData.period === "YEAR" ? true : false}
                      name="interval"
                      id="interval"
                      className="custom_plan_input"
                      value={planData.interval}
                      onChange={handleChange}
                    >
                      {Object.entries(
                        enumsData?.data?.subscriptionType["plan_intervals"]
                      ).map(([Key, val], i) => (
                        <option value={val}>{Key}</option>
                      ))}
                    </select>
                  </div>
                ) : (
                  <div>
                    <label for="interval">Enter Days</label>
                    <input
                      type="number"
                      id="interval"
                      name="interval"
                      className="custom_plan_input"
                      value={planData.interval}
                      placeholder="Please enter amount"
                      onChange={handleChange}
                      step="any"
                    ></input>
                  </div>
                )} */}
              </div>

              <div>
                <div>
                  <label for="currency">Select Currency</label>
                  <select
                    id="currency"
                    name="currency"
                    className="custom_plan_input"
                    onChange={handleChange}
                    value={planData.currency}
                  >
                    {Object.entries(
                      enumsData?.data?.subscriptionType["plan_currency"]
                    ).map(([Key, val], i) => (
                      <option value={val}>{val}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label for="amount">Enter Amount</label>
                  <input
                    type="number"
                    id="amount"
                    name="amount"
                    style={{ border: "1px solid #d1d1d1" }}
                    className="custom_plan_input"
                    value={Number(planData.amount).toString()}
                    placeholder="Please enter amount"
                    onChange={handleChange}
                    step="any"
                  ></input>
                </div>
              </div>
              <div>
                <div>
                  <label for="before_discount_amount">
                    Amount Before Discout
                  </label>
                  <input
                    type="number"
                    id="before_discount_amount"
                    name="before_discount_amount"
                    className="custom_plan_input"
                    value={planData.before_discount_amount}
                    placeholder="Please enter amount"
                    onChange={handleChange}
                    step="any"
                  ></input>
                </div>
                <div style={{ display: "none" }}>
                  <label for="position">Offer</label>
                  <input
                    type="number"
                    id="Position"
                    name="Position"
                    className="custom_plan_input"
                    value={planData.position}
                    placeholder="Please enter amount"
                    onChange={handleChange}
                    step="any"
                  ></input>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="popup-footer">
          <div>
            <button onClick={handleSave}>Save</button>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default AddPlan;
